export default __webpack_public_path__ + "static/media/knowshops.520b2c3e.png";